import { FC, useState, useEffect, useMemo } from 'react';
import { useIsFetching, useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import { ROUTES } from 'module/navigation/enums/routes.enums';

import useModal from 'core/hooks/useModal';
import { useAuth } from 'module/auth/context/AuthContext';

import { useWorkplacesContext } from 'module/workplaces/context/WorkplacesContext';

import logo from 'assets/icons/Mabel_Logo_Blue.png';
import hamburger from 'assets/icons/Hamburger.svg';
import highPriority from 'assets/icons/HighPriorityIcon.svg';
import lowPriority from 'assets/icons/LowPriorityIcon.svg';
import mediumPriority from 'assets/icons/MediumPriorityIcon.svg';

import MobileMenu from 'core/components/MobileMenu/MobileMenu';
import SvgIcon from 'shared/components/SvgIcon/SvgIcon';

// CSS modules
import NavigationMenu from 'components/featured/navigation/NavigationMenu';
import NotificationsMenu from 'components/featured/navigation/NotificationsMenu';

import { DocumentModal } from 'module/documents/DocumentModal';
import Header from './HeaderBar.module.scss';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useWorkplaceUser } from 'module/documents/utils';
import { useDocumentContext } from 'module/documents/context';
import MaskedDateInput from 'shared/utils/dates/MaskedDateInput';
import EventsDatePicker from 'module/events/components/EventsDatePicker';
import moment from 'moment';
import { getOrganizations, getDays } from 'core/API/organizationSettings';

import {
	Dialog,
	DialogTitle,
	DialogContent,
	TextField,
	Button,
	Grid,
	Typography,
	Divider,
	Box,
	IconButton,
	CircularProgress,
} from '@mui/material';
import logbookLogo from 'assets/images/LogbookWordIcons.png';
import CheckListLogo from '../../../assets/images/ChecklistIcon.png';
import GuestConnectLogo from '../../../assets/images/GuestConnectWordIcon.png';
import TodoWordIcon from '../../../assets/images/TodoWordIcon.png';
import GameMasterLogo from '../../../assets/images/gameMasterWordIcons.png';
import SchedulerLogo from '../../../assets/images/newSchedulerWordIcon.png';
import OnboardingLogo from '../../../assets/images/newOnboardingWordIcon.png';

import DashboardLogo from '../../../assets/images/newDashboardWordIcon.png';
import MabelScoreCardIcon from '../../../assets/images/newScoreCardWordIcon.png';

import MabelEventIcon from '../../../assets/images/EventCalenderWordIcon.png';
import BroadcastLogo from '../../../assets/images/newBroadcastWordIcon.png';
import useHeaderStore from 'store/useHeaderStore';

const _HeaderPriorityIcon = ({ isCurrMaxPriorityFetched, currMaxPriority }) => {
	const isFetching = useIsFetching();

	if (isFetching) {
		return <CircularProgress color="inherit" size={25} />;
	}
	switch (isCurrMaxPriorityFetched && currMaxPriority?.top_priority) {
		case 'Low':
			return <SvgIcon spriteUrl={lowPriority} className={Header.navIconLow} />;
		case 'Medium':
			return <SvgIcon spriteUrl={mediumPriority} className={Header.navIconMedium} />;
		case 'High':
			return <SvgIcon spriteUrl={highPriority} className={Header.navIconHigh} />;
		case 'Urgent':
			return <SvgIcon spriteUrl={highPriority} className={Header.navIconHigh} />;
		default:
			return null;
	}
};

const HeaderBar: FC = (): JSX.Element => {
	const _auth = useAuth();

	const [tempStartDate, setTempStartDate] = useState('');
	const [tempEndDate, setTempEndDate] = useState('');
	const { workplaceId: _workplaceId } = useWorkplacesContext();
	const { startDate, setStartDate, endDate, setEndDate, businessWeekStart, setBusinessWeekStart, scheduleView } =
		useDocumentContext();
	const {
		open: isMobileMenuOpen,
		openModal: openMobileMenu,
		closeModal: closeMobileMenu,
	} = useModal();
	// const { data: currMaxPriority, isFetched: isCurrMaxPriorityFetched } = useQuery(['top-priority'], () =>
	// 	fetchTopPriority(workplaceId)
	// );
	// const { data } = useQuery('notifications', GetNotifications, {});
	const dataa = useWorkplaceUser();
	const [isDateModalOpen, setDateModalOpen] = useState(false);
	const location = useLocation();
	const [_headerText, _setHeaderText] = useState('');
	const [eventsDate, setEventsDate] = useState(() => {
		return localStorage.getItem('events-selected-date') || moment().format('YYYY-MM-DD');
	});

	const calenderCheck = useHeaderStore((state) => state.headerTitle);

	useEffect(() => {
		const today = moment().format('YYYY-MM-DD');

		if (location.pathname === ROUTES.CHECKLIST) {
			const storedDate = localStorage.getItem('checklist-selected-date');
			const nextDate = storedDate || today;
			setStartDate(nextDate);
			if (!storedDate) {
				localStorage.setItem('checklist-selected-date', nextDate);
			}
		} else if (location.pathname === ROUTES.TO_DO) {
			const storedDate = localStorage.getItem('todo-selected-date');
			const nextDate = storedDate || today;
			setStartDate(nextDate);
			if (!storedDate) {
				localStorage.setItem('todo-selected-date', nextDate);
			}
		} else if (location.pathname === ROUTES.LOGBOOK) {
			const storedDate = localStorage.getItem('logbook-selected-date');
			const nextDate = storedDate || today;
			setStartDate(nextDate);
			if (!storedDate) {
				localStorage.setItem('logbook-selected-date', nextDate);
			}
		} else if (location.pathname === ROUTES.EVENTS) {
			const storedDate = localStorage.getItem('events-selected-date');
			const nextDate = storedDate || today;
			setEventsDate(nextDate);
			if (!storedDate) {
				localStorage.setItem('events-selected-date', nextDate);
			}
			window.dispatchEvent(new CustomEvent('events-date-changed', { detail: nextDate }));
		}
	}, [location.pathname, setStartDate, setEventsDate]);

	const handleOpenDateModal = () => {
		setDateModalOpen(true);
	};
	const handleCloseDateModal = () => {
		// console.log('Start Date:', startDate);
		// console.log('End Date:', endDate);
		setDateModalOpen(false);
		setTempStartDate('');
		setStartDate('');
		setEndDate('');
	};
	const handleLogbookDate = () => {
		setStartDate(tempStartDate);
		setDateModalOpen(false);
	};
	const handleClearDates = () => {
		setStartDate('');
		setEndDate('');
	};

	const handleWTD = () => {
		const today = new Date();
		const day = today.getDay(); // 0 (Sun) to 6 (Sat)
		const diffToMonday = day === 0 ? 6 : day - 1;
		const monday = new Date(today);
		monday.setDate(today.getDate() - diffToMonday);
		setStartDate(monday.toISOString().split('T')[0]);
		setEndDate(today.toISOString().split('T')[0]);
	};

	const handlePTD = () => {
		const today = new Date();
		const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
		setStartDate(firstDay.toISOString().split('T')[0]);
		setEndDate(today.toISOString().split('T')[0]);
	};

	const handleUTD = () => {
		const today = new Date();
		const start = new Date();
		setStartDate(start.toISOString().split('T')[0]);
		setEndDate(today.toISOString().split('T')[0]);
	};

	const handlePeriod = () => {
		const today = new Date();
		const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
		setStartDate(firstDay.toISOString().split('T')[0]);
		setEndDate(today.toISOString().split('T')[0]);
	};

	const handlePriorYear = () => {
		if (!startDate || !endDate) {
			alert('Please select both Start and End dates before using Prior Year.');
			return;
		}
		const prevStart = new Date(startDate);
		const prevEnd = new Date(endDate);
		prevStart.setFullYear(prevStart.getFullYear() - 1);
		prevEnd.setFullYear(prevEnd.getFullYear() - 1);
		setStartDate(prevStart.toISOString().split('T')[0]);
		setEndDate(prevEnd.toISOString().split('T')[0]);
	};

	const isScoreCardPage = location.pathname === ROUTES.SCORECARD;
	const isDashboardPage = location.pathname === ROUTES.DASHBOARD;
	const isLogbookPage = [
		ROUTES.LOGBOOK,
		ROUTES.ADD_SHIFT_NOTES,
		ROUTES.EDIT_SHIFT_NOTES,
		ROUTES.ADD_EMPLOYEE_NOTES,
		ROUTES.EDIT_EMPLOYEE_NOTES,
		ROUTES.ADD_SALES_TRAFFIC_NOTES,
	]
		.map((route) => route.split(':')[0])
		.some((base) => location.pathname.startsWith(base));
	const isMainLogbookPage = location.pathname === ROUTES.LOGBOOK; // Only the main logbook page
	const isHyperSchedulerPage = location.pathname === ROUTES.HYPERSCHEDULER;
	const isSchedulerPage = location.pathname === ROUTES.HYPERSCHEDULER;
	const isChecklist = location.pathname === ROUTES.CHECKLIST;
	const isGuestConnectPage = location.pathname === ROUTES.GUESTCONNECT;
	const isToDoPage = location.pathname === ROUTES.TO_DO;
	const isAddToDoPage = location.pathname === ROUTES.ADD_TO_DO;
	const isGameMasterPage = location.pathname === ROUTES.GAMEMASTER;
	const isEventsPage = location.pathname === ROUTES.EVENTS;
	const isOnboardingPage = location.pathname === ROUTES.ONBOARDING;
	const isBroadcastPage = location.pathname === ROUTES.BROADCAST || location.pathname.includes('/broadcast/');
	const _isGetToDoPage = location.pathname === ROUTES.TO_DO_ID;

	// Fetch organization settings for business week start
	const { data: organizationData } = useQuery('organizations', () => getOrganizations(), {
		staleTime: 300000,
		enabled: isHyperSchedulerPage,
	});

	// Fetch days data to convert day IDs to labels
	const { data: daysData } = useQuery('days', () => getDays(), {
		staleTime: 300000,
		enabled: isHyperSchedulerPage,
	});

	// Get start_of_week from organization and convert from /api/days/id format to day label
	const startOfWeek = useMemo(() => {
		const startOfWeekId = organizationData?.data?.[0]?.start_of_week;
		if (!startOfWeekId || !daysData) return 'Monday';
		
		// Convert /api/days/id format to day label
		const dayObj = daysData.find((day: any) => {
			const dayId = day['@id'] || `/api/days/${day.id}`;
			return dayId === startOfWeekId;
		});
		
		return dayObj?.label || 'Monday';
	}, [organizationData, daysData]);
	// Calculate current business week on mount or when startOfWeek changes
	useEffect(() => {
		if (isHyperSchedulerPage && startOfWeek) {
			const dayMap: { [key: string]: number } = {
				Sunday: 0,
				Monday: 1,
				Tuesday: 2,
				Wednesday: 3,
				Thursday: 4,
				Friday: 5,
				Saturday: 6,
			};

			const startDayOfWeek = dayMap[startOfWeek] ?? 1;
			const currentDate = moment();
			const currentDayOfWeek = currentDate.day();

			let daysBack = currentDayOfWeek - startDayOfWeek;
			if (daysBack < 0) {
				daysBack += 7;
			}

			const weekStart = currentDate.clone().subtract(daysBack, 'days');
			setBusinessWeekStart(weekStart.format('YYYY-MM-DD'));
		}
	}, [isHyperSchedulerPage, startOfWeek, setBusinessWeekStart]); // Handler to navigate to previous business week
	const handlePreviousWeek = () => {
		if (!businessWeekStart) return;
		const prevWeek = moment(businessWeekStart).subtract(7, 'days');
		setBusinessWeekStart(prevWeek.format('YYYY-MM-DD'));
	};

	// Handler to navigate to next business week
	const handleNextWeek = () => {
		if (!businessWeekStart) return;
		const nextWeek = moment(businessWeekStart).add(7, 'days');
		setBusinessWeekStart(nextWeek.format('YYYY-MM-DD'));
	};

	// Handler to navigate to current business week
	const _handleTodayWeek = () => {
		const dayMap: { [key: string]: number } = {
			Sunday: 0,
			Monday: 1,
			Tuesday: 2,
			Wednesday: 3,
			Thursday: 4,
			Friday: 5,
			Saturday: 6,
		};

		const startDayOfWeek = dayMap[startOfWeek] ?? 1;
		const currentDate = moment();
		const currentDayOfWeek = currentDate.day();

		let daysBack = currentDayOfWeek - startDayOfWeek;
		if (daysBack < 0) {
			daysBack += 7;
		}

		const weekStart = currentDate.clone().subtract(daysBack, 'days');
		setBusinessWeekStart(weekStart.format('YYYY-MM-DD'));
	};

	// Format business week display
	const _formatBusinessWeek = () => {
		if (!businessWeekStart) return '';
		const weekStart = moment(businessWeekStart);
		const weekEnd = weekStart.clone().add(6, 'days');

		if (weekStart.month() === weekEnd.month()) {
			return `${weekStart.format('MMM D')} - ${weekEnd.format('D, YYYY')}`;
		}
		return `${weekStart.format('MMM D')} - ${weekEnd.format('MMM D, YYYY')}`;
	};

	// Format the date to display in the read-only input
	const formatWeekStartDisplay = () => {
		if (!businessWeekStart) return '';
		const weekStart = moment(businessWeekStart);

		// Always show "Week of [start date]" format
		return `Week of ${weekStart.format('MM/DD/YYYY')}`;
	};

	useEffect(() => {
		if (!startDate) return;

		if (location.pathname === ROUTES.CHECKLIST) {
			localStorage.setItem('checklist-selected-date', startDate);
		} else if (location.pathname === ROUTES.TO_DO) {
			localStorage.setItem('todo-selected-date', startDate);
		} else if (location.pathname === ROUTES.LOGBOOK) {
			localStorage.setItem('logbook-selected-date', startDate);
		}
	}, [startDate, location.pathname]);

	const { logoToUse, altText, logoClassName } = useMemo(() => {
		if (isLogbookPage) {
			return {
				logoToUse: logbookLogo,
				altText: 'Logbook logo',
				logoClassName: Header.headerLogbookLogo,
			};
		} else if (isGuestConnectPage) {
			return {
				logoToUse: GuestConnectLogo,
				altText: 'Guest Connect logo',
				logoClassName: Header.headerGuestConnectLogo,
			};
		} else if (isSchedulerPage) {
			return {
				logoToUse: SchedulerLogo,
				altText: 'Scheduler logo',
				logoClassName: Header.headerSchedulerLogo,
			};
		} else if (isOnboardingPage) {
			return {
				logoToUse: OnboardingLogo,
				altText: 'Onboarding logo',
				logoClassName: Header.headerSchedulerLogo,
			};
		} else if (isChecklist) {
			return {
				logoToUse: CheckListLogo,
				altText: 'Checklist logo',
				logoClassName: Header.headerChecklistLogo,
			};
		} else if (isToDoPage || isAddToDoPage || location.pathname.startsWith(ROUTES.TO_DO)) {
			return {
				logoToUse: TodoWordIcon,
				altText: 'Todo logo',
				logoClassName: Header.headerChecklistLogo,
			};
		} else if (isGameMasterPage) {
			return {
				logoToUse: GameMasterLogo,
				altText: 'GameMaster logo',
				logoClassName: Header.headerGameMasterLogo,
			};
		} else if (isDashboardPage) {
			return {
				logoToUse: DashboardLogo,
				altText: 'Dashboard logo',
				logoClassName: Header.headerDashboardLogo,
			};
		} else if (isScoreCardPage) {
			return {
				logoToUse: MabelScoreCardIcon,
				altText: 'Scorecard logo',
				logoClassName: Header.headerLogo,
			};
		} else if (isEventsPage) {
			return {
				logoToUse: MabelEventIcon,
				altText: 'Events logo',
				logoClassName: Header.headerEventLogo,
			};
		} else if (isBroadcastPage) {
			return {
				logoToUse: BroadcastLogo,
				altText: 'Broadcast logo',
				logoClassName: Header.headerLogo,
			};
		} else {
			return {
				logoToUse: logo,
				altText: 'BYOD logo',
				logoClassName: Header.headerLogo,
			};
		}
	}, [
		isLogbookPage,
		isGuestConnectPage,
		isSchedulerPage,
		isOnboardingPage,
		isChecklist,
		isToDoPage,
		isAddToDoPage,
		isGameMasterPage,
		isDashboardPage,
		isScoreCardPage,
		isEventsPage,
		isBroadcastPage,
		location.pathname,
	]);

	const tenantName = localStorage.getItem('BYOD-organizationId') || dataa?.userOrg?.id || 'N/A';
	// console.log("workplace name", dataa?.workplace);
	return (
		<div>
			<header className={Header.header}>
				<SvgIcon
					spriteUrl={hamburger}
					className={Header.navHamIcon}
					onClick={() => openMobileMenu()}
				/>
				<div>
					<img
						key={location.pathname}
						src={logoToUse}
						alt={altText}
						className={logoClassName}
					/>
					<div className={Header.header_info}>
						<ul>
							<li>{tenantName}</li>
							<li>
								{dataa.workplace.workplaceUnitNumber} {dataa?.workplace?.name}{' '}
							</li>
							<li>{new Date().toLocaleDateString('en-US')}</li>
						</ul>
					</div>
				</div>
				<nav className={Header.nav}>
					<div></div>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						{isScoreCardPage && (
							<Button
								style={{
									backgroundColor: 'rgb(68, 99, 136)',
									color: 'white',
									padding: '5px 12px',
									marginRight: '10px',
								}}
								onClick={handleOpenDateModal}
							>
								Pick a Date
							</Button>
						)}
						{/* {isHyperSchedulerPage && <MaskedDateInput date={startDate} setDate={setStartDate} />} */}
						{isMainLogbookPage && <MaskedDateInput date={startDate} setDate={setStartDate} />}
						{isChecklist && calenderCheck && (
							<MaskedDateInput date={startDate} setDate={setStartDate} />
						)}
						{isEventsPage && (
							<EventsDatePicker
								date={eventsDate}
								setDate={(newDate: string) => {
									setEventsDate(newDate);
									localStorage.setItem('events-selected-date', newDate);
									// Trigger a custom event to notify Events.tsx
									window.dispatchEvent(new CustomEvent('events-date-changed', { detail: newDate }));
								}}
							/>
						)}
						{/* {isToDoPage && <MaskedDateInput date={startDate} setDate={setStartDate} />} */}
						{isHyperSchedulerPage && businessWeekStart && (scheduleView === 'scheduler' || scheduleView === 'add-shift' || scheduleView === 'edit-shift') && (
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 2 }}>
								{/* Left Arrow Button */}
								<IconButton
									onClick={handlePreviousWeek}
									sx={{
										backgroundColor: 'rgb(68, 99, 136)',
										color: '#fff',
										borderRadius: '8px',
										width: '40px',
										height: '40px',
										boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
										'&:hover': {
											backgroundColor: 'rgb(50, 75, 105)',
											transform: 'scale(1.05)',
										},
									}}
								>
									<ArrowBackIosNewIcon fontSize="small" />
								</IconButton>

								{/* Read-only Date Display */}
								<TextField
									value={formatWeekStartDisplay()}
									variant="outlined"
									size="small"
									InputProps={{
										readOnly: true,
									}}
									sx={{
									width: 210,
										'& .MuiOutlinedInput-root': {
											borderRadius: '6px',
											fontSize: '0.95rem',
											backgroundColor: '#fff',
											color: '#3c5471',
											fontFamily: 'Gotham',
											'& fieldset': {
												border: '1px solid rgba(0,0,0,0.23)',
											},
											'&:hover fieldset': {
												border: '1px solid rgba(0,0,0,0.23)',
											},
											'&.Mui-focused fieldset': {
												border: '1px solid rgba(0,0,0,0.23)',
											},
										},
										'& input': {
											textAlign: 'center',
											fontFamily: 'Gotham',
											letterSpacing: '1px',
											fontWeight: 'bold',
											color: '#3c5471',
											cursor: 'default',
										},
									}}
								/>

								{/* Right Arrow Button */}
								<IconButton
									onClick={handleNextWeek}
									sx={{
										backgroundColor: 'rgb(68, 99, 136)',
										color: '#fff',
										borderRadius: '8px',
										width: '40px',
										height: '40px',
										boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
										'&:hover': {
											backgroundColor: 'rgb(50, 75, 105)',
											transform: 'scale(1.05)',
										},
									}}
								>
									<ArrowForwardIosIcon fontSize="small" />
								</IconButton>
							</Box>
						)}
						<section className={Header.headerInfo}>
							<DocumentModal />
							{/* <ChatKit /> */}
							<NotificationsMenu data={{ items: [] }} />
							<NavigationMenu />
						</section>
						<Dialog
							open={isDateModalOpen}
							onClose={handleCloseDateModal}
							fullWidth={!isMainLogbookPage}
							maxWidth={isMainLogbookPage ? 'xs' : 'sm'}
							PaperProps={{
								sx: isMainLogbookPage ? { borderRadius: 2, minWidth: '300px' } : {},
							}}
						>
							{!isMainLogbookPage && <DialogTitle>Date Range</DialogTitle>}
							<DialogContent>
								<Grid container spacing={2}>
									<Grid item xs={5}>
										{!isMainLogbookPage && (
											<ul className={Header.date_range}>
												<li onClick={handleWTD}>Week to Date</li>
												<li onClick={handlePTD}>Period to Date</li>
												<li onClick={handleUTD}>Year to Date</li>
												<li onClick={handlePeriod}>Period</li>
												<li onClick={handlePriorYear}>Prior Year</li>
											</ul>
										)}
									</Grid>
									<Grid item xs={isMainLogbookPage ? 12 : 7}>
										<Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }}>
											<Box
												sx={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
												}}
											>
												{!isMainLogbookPage && (
													<Typography variant="subtitle2">Start Date</Typography>
												)}
												{isMainLogbookPage && (
													<Typography variant="subtitle2">Select Date</Typography>
												)}
												<Button onClick={() => setStartDate('')} size="small">
													Clear
												</Button>
											</Box>
											<TextField
												type="date"
												fullWidth
												value={tempStartDate}
												onChange={(e) => setTempStartDate(e.target.value)}
												InputLabelProps={{ shrink: true }}
												sx={{ mt: 1, width: '100%' }}
											/>
										</Box>
										{!isMainLogbookPage && (
											<Box sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
												<Box
													sx={{
														display: 'flex',
														justifyContent: 'space-between',
														alignItems: 'center',
													}}
												>
													<Typography variant="subtitle2">End Date</Typography>
													<Button onClick={() => setEndDate('')} size="small">
														Clear
													</Button>
												</Box>
												<TextField
													type="date"
													fullWidth
													value={tempEndDate}
													onChange={(e) => setTempEndDate(e.target.value)}
													InputLabelProps={{ shrink: true }}
													sx={{ mt: 1 }}
												/>
											</Box>
										)}
									</Grid>
								</Grid>
								<Divider sx={{ my: 2 }} />
								<div style={{ display: 'flex', justifyContent: 'space-between' }}>
									<Button
										onClick={handleClearDates}
										sx={{
											mr: 1,
											visibility: isMainLogbookPage ? 'hidden' : 'visible',
										}}
									>
										Clear
									</Button>
									<div>
										<Button onClick={handleCloseDateModal} sx={{ mr: 1 }}>
											Cancel
										</Button>
										<Button
											onClick={() => {
												if (isMainLogbookPage) {
													handleLogbookDate();
												} else {
													handleCloseDateModal();
												}
											}}
											disabled={
												(isMainLogbookPage && !tempStartDate) ||
												(!isMainLogbookPage && (!tempStartDate || !tempEndDate))
											}
											style={{
												backgroundColor:
													(isMainLogbookPage && !tempStartDate) ||
													(!isMainLogbookPage && (!tempStartDate || !tempEndDate))
														? 'gray'
														: 'rgb(68, 99, 136)',
												color: 'white',
												padding: '5px 12px',
											}}
										>
											Apply
										</Button>
									</div>
								</div>
							</DialogContent>
						</Dialog>
					</div>
				</nav>
			</header>
			{isMobileMenuOpen && <MobileMenu close={() => closeMobileMenu()} />}
		</div>
	);
};

export default HeaderBar;
